export default __webpack_public_path__ + "static/media/logo.5d20c7a1.png";